import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import { NotificationSettingsModel } from '~/models/NotificationSettingsModel';
import { PracticeManagement } from '~/types/api.model';
export var Tab = /*#__PURE__*/ function(Tab) {
    Tab["Vendor"] = "vendor";
    Tab["Client"] = "customer";
    return Tab;
}({});
export var Table = /*#__PURE__*/ function(Table) {
    Table["Notifications"] = "notifications";
    Table["Reminders"] = "reminders";
    return Table;
}({});
export const notificationColumnDefs = [
    {
        width: 400
    },
    {
        width: 210
    },
    {
        width: 200
    }
];
export const notificationHeaderItems = [
    {
        value: 'Event Name'
    },
    {
        value: 'Status'
    },
    {
        value: 'Notified Team Member'
    }
];
const clientReminderColumnDefs = [
    {
        width: 400
    },
    {
        width: 60
    },
    {
        width: 80
    },
    {
        width: 40
    },
    {
        width: 140
    }
];
const clientReminderHeaderItems = [
    {
        value: 'Delayed Action'
    },
    {
        value: 'Status'
    },
    {
        value: 'Interval'
    },
    {
        value: 'Retries'
    },
    {
        value: 'Notified Team Member'
    }
];
const vendorReminderColumnDefs = [
    {
        width: 400
    },
    {
        width: 100
    },
    {
        width: 100
    },
    {
        width: 200
    }
];
const vendorReminderHeaderItems = [
    {
        value: 'Delayed Action'
    },
    {
        value: 'Status'
    },
    {
        value: 'Delay'
    },
    {
        value: 'Notified Team Member'
    }
];
export const reminderColumnDefsMap = {
    ["vendor"]: vendorReminderColumnDefs,
    ["customer"]: clientReminderColumnDefs
};
export const reminderHeaderItemsMap = {
    ["vendor"]: vendorReminderHeaderItems,
    ["customer"]: clientReminderHeaderItems
};
function getVendorNotificationToShowTextMap(param) {
    let { showKarbonIntegration, showClientHubIntegration, showFinancialCentsIntegration, showKeeperIntegration } = param;
    const map = {
        relationshipApprovedVendor: 'Proposal signed',
        relationshipAmendmentsApprovedVendor: 'Amendment approved',
        paymentFailedVendor: 'Payment failed',
        invoiceRefundedVendor: 'Payment refunded',
        invoiceRefundFailedVendor: 'Refund failed',
        payoutDepositedVendor: 'Payout deposited',
        proposalNotSignedReminderVendor: 'Proposal not signed',
        amendmentsNotApprovedReminderVendor: 'Amendment not approved',
        bankAccountNotVerifiedReminderVendor: 'Bank account not verified',
        payoutFailedVendor: 'Payout failed'
    };
    if (showFinancialCentsIntegration) map.relationshipFinancialCentsFailedItems = "".concat(getPMDetails(PracticeManagement.FinancialCents).name, " project creation failed");
    if (showKarbonIntegration) map.relationshipKarbonFailedItems = "".concat(getPMDetails(PracticeManagement.Karbon).name, " work item creation failed");
    if (showClientHubIntegration) map.relationshipClientHubFailedItems = "".concat(getPMDetails(PracticeManagement.ClientHub).name, " project creation failed");
    if (showKeeperIntegration) map.relationshipKeeperFailedItems = "".concat(getPMDetails(PracticeManagement.Keeper).name, " task creation failed");
    return map;
}
const getClientNotificationToShowTextMap = (_)=>({
        invoiceIssuedAutoProcess: 'Invoice issued',
        relationshipApprovedCustomer: 'Agreement approved',
        invoiceIssuedRequiresApproval: 'Invoice requires approval',
        paymentFailedCustomer: 'Payment failed',
        relationshipUpdatedWithChanges: 'Agreement amended',
        invoiceRefundedCustomer: 'Payment refunded',
        proposalNotSignedReminderCustomer: 'Proposal not signed',
        amendmentApprovalReminderCustomer: 'Amendment not approved',
        bankAccountNotVerifiedReminderCustomer: 'Bank account not verified'
    });
export function getNotificationsToShow(opts) {
    const getTextMap = opts.tab === "vendor" ? getVendorNotificationToShowTextMap : getClientNotificationToShowTextMap;
    return getTextMap(opts);
}
const vendorProposalNotifications = [
    'proposalNotSignedReminderVendor',
    'relationshipApprovedVendor'
];
export const getRecipientTypeTextMap = (notificationName)=>({
        all: notificationName === 'proposalNotSignedReminderCustomer' ? "Primary Contact\nSignatories" : 'All team members',
        owner: 'Owner',
        admin: 'Admin',
        assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team member'
    });
export const getEditDropdownRecipientTypeText = (notificationName)=>({
        all: 'All team members',
        owner: 'Users with Owner role',
        admin: 'Users with Admin role',
        assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team member'
    });
export const getRecipientTypesText = (recipientTypes, notificationName)=>recipientTypes.includes('all') ? [
        getRecipientTypeTextMap(notificationName).all
    ] : recipientTypes.map((recipientType)=>getRecipientTypeTextMap(notificationName)[recipientType]);
export const minutesToDays = (minutes)=>Math.floor(minutes / 60 / 24);
export const daysToMinutes = (days)=>days * 60 * 24;
export const isDays = (minutes)=>minutes % (60 * 24) === 0;
export const handleSetRecipientTypes = (param)=>{
    let { newType, newRecipientTypes, setRecipientTypes } = param;
    setRecipientTypes(newRecipientTypes.includes('all') ? newType === 'all' ? [
        'all'
    ] : newRecipientTypes.filter((x)=>x !== 'all') : newRecipientTypes);
};
export const getFallbackRecipientTypes = (param)=>{
    let { recipientTypes, defaultRecipientType, originalRecipientTypes } = param;
    return NotificationSettingsModel.hasRecipients({
        recipientTypes
    }) ? [] : NotificationSettingsModel.hasRecipients({
        recipientTypes: originalRecipientTypes
    }) ? originalRecipientTypes : [
        defaultRecipientType
    ];
};
export const getEmailProviderDetails = (provider)=>({
        biCodes: ({
            gmail: {
                connect: 18501,
                completeAuth: 18502,
                authError: 18503,
                disconnect: 18504
            },
            outlook: {
                connect: 18511,
                completeAuth: 18512,
                authError: 18513,
                disconnect: 18514
            }
        })[provider]
    });
